import { Login } from "../../services";
import authBloc from "../../services/bloc";
import { alertError } from "@cems-eco/core/src/utils/widget";
import { Validators } from "@cems-eco/core/src/utils/validator";
import guard from '@/guard';
import { Vue } from "vue-class-component";
import environment from "@/config";
import { ElLoading } from 'element-plus';
import { isEmpty } from "lodash";
import { GuardService } from "@/guard/base";
import { BaseAuthBloc } from "../../services/bloc.base";

export class BaseLogin extends Vue {
    loginBloc: BaseAuthBloc = authBloc;
    guard: GuardService = guard;
    socials: any[] =  [];
    rules: any = {
        email: { type: "email" },
        password: { type: "string", min: 1, }
    };

    login = new Validators<Login>({
        value: new Login,
        rules: this.rules
    });

    logo() {
        return environment.white_label.asset.logo;
    }

    async authenticate() {
        const loader = ElLoading.service({ lock: true });
        try {
            await this.guard.checkProviderStatus();
            const response = await this.loginBloc.login(this.login.value);
            await this.loginBloc.saveStorage(response);
            await this.guard.checkAuthentication();
        } catch (e) {

            alertError(e);
        }
        loader.close();

    }

    socialLogin(social: any) {
        window.location.href = social.point;
    }

    isSocialEmpty() {
        return isEmpty(this.socials);
    }
}

